<div class="wrapper">
    <div class="title">Rotate to Landscape</div>
    <ng-lottie
        class="rotate-phone"
        containerClass="rotate-phone-container"
        [options]="{ path: 'assets/animations/RotateLandscape.json' }"></ng-lottie>
    <div class="bottom-text">To make the best of Shuffll, please rotate your device to landscape featureFlagMode</div>
</div>
